import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import Layout from './components/Layout';
import Home from './components/Pages/Home';
import About from './components/Pages/About';
import Products from './components/Pages/Products';
import Services from './components/Pages/Services';
import Login from './components/Pages/Login';
import NotFound from './components/Pages/NotFound';
import { ThemeProvider } from '@material-tailwind/react/context/theme';
import useToken from './services/useToken';
import parseJwt from './services/parseJwt';
import { PrivateRoute } from './services/PrivateRoute';
import Profile from './components/Pages/Profile';
import AdminProduct from './AdminPage/AdminProduct';
import AdminAddProduct from './AdminPage/AdminAddProduct';
import AdminUser from './AdminPage/AdminUser';
import PaymentFinish from './components/Pages/PaymentFinish';
import useCart from './services/useCart';
import { useCartFunctions } from './services/ApiServices/CartProductService';
import Dashboard from './components/Dashboard/Dashboard';
import Payment from './components/Pages/Payment';
import Order from './components/Pages/Order';
import AdminProductDetail from './AdminPage/AdminProductDetail';
import OrderDetail from './components/Pages/OrderDetail';
import AdminOrders from './AdminPage/AdminOrder';
import AdminOrderDetail from './AdminPage/AdminOrderDetail';
import ProductDetail from './components/Pages/ProductDetail';
import AdminCreateBlog from './AdminPage/AdminCreateBlog';
import Blog from './components/Pages/Blog';
import Chart from './components/Dashboard/Chart';
import ChartPage from './components/Dashboard/ChartPage';
import AdminBlogManagement from './AdminPage/AdminBlogManagement';
import ProductComparison from './components/Pages/ProductComparison';
import ForgotPassword from './components/Pages/ForgotPassword';


export default function App() {
    const { token, setToken, removeToken } = useToken();
    const { cart, addToCart, removeProduct } = useCart();

    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const role = token ? parseJwt(token).role : null;
    const id = token ? parseJwt(token).id : null;

    const [cartProducts, setCartProducts] = useState([]);
    const [selectedProducts, setSelectedProducts] = React.useState([]);
    const [totalPrice, setTotalPrice] = useState(0);

    const {
        GetAllProductsByUserId,
        GetProductSize,
        UpdateProductQuantity,
        AddToCart,
        DeleteCartProduct
    } = useCartFunctions({ cart, addToCart, removeProduct });



    const fetchProductsInCart = async () => {
        let products = null;
        try {
            products = await GetAllProductsByUserId(id);
        }
        catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('An error occurred. Please try again later.');
            }
            return;
        }
    }

    useEffect(() => {
        fetchProductsInCart();
    }, [])

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Layout
                    setSuccessMessage={setSuccessMessage}
                    UpdateProductQuantity={UpdateProductQuantity}
                    GetAllProductsByUserId={GetAllProductsByUserId}
                    DeleteCartProduct={DeleteCartProduct}
                    token={token}
                    products={cart} setProducts={setCartProducts}
                    removeToken={removeToken} setToken={setToken}
                    selectedProducts={selectedProducts}
                    setSelectedProducts={setSelectedProducts}
                    totalPrice={totalPrice} setTotalPrice={setTotalPrice}
                    role={role} loading={loading} successMessage={successMessage} />}>
                    {/*User pages*/}
                    <Route index element={<Home loading={loading} setLoading={setLoading} />}></Route>
                    <Route path='/order' element={<Order id={id} setLoading={setLoading} />}></Route>
                    <Route path="order-detail" element={<OrderDetail
                        uid={id}
                        setLoading={setLoading} />} >
                        <Route path=":id" element={<OrderDetail
                            uid={id}
                            setLoading={setLoading} />} />
                    </Route>

                    <Route path="/about" element={
                        <>
                            <About />
                        </>
                    }></Route>
                    <Route path="product-detail" element={<ProductDetail
                        GetProductSize={GetProductSize}
                        GetAllProductsByUserId={GetAllProductsByUserId}
                        AddToCart={AddToCart}
                        token={token} setProducts={setCartProducts}
                        setSuccessMessage={setSuccessMessage} setLoading={setLoading} />} >
                        <Route path=":id" element={<ProductDetail
                            GetProductSize={GetProductSize}
                            GetAllProductsByUserId={GetAllProductsByUserId}
                            AddToCart={AddToCart}
                            token={token} setProducts={setCartProducts}
                            setSuccessMessage={setSuccessMessage} setLoading={setLoading} />} />
                    </Route>
                    <Route path="/products" element={<Products types={[""]} loading={loading} setLoading={setLoading} />}></Route>
                    <Route path="/clothes" element={<Products types={["Áo", "Quần"]} loading={loading} setLoading={setLoading} />}></Route>
                    <Route path="/shoes" element={<Products types={["Giày"]} loading={loading} setLoading={setLoading} />}></Route>
                    <Route path="/bags" element={<Products types={["Túi"]} loading={loading} setLoading={setLoading} />}></Route>
                    <Route path="/watches" element={<Products types={["Đồng hồ"]} loading={loading} setLoading={setLoading} />}></Route>
                    <Route path="/services" element={<Services />}></Route>
                    <Route path="/compare-products" element={<ProductComparison setLoading={setLoading} />}></Route>
                    <Route path="/payment" element={<Payment token={token} fetchCartProducts={fetchProductsInCart}
                        setSelectedProducts={setSelectedProducts}
                        setSelectedProductsPrice={setTotalPrice} selectedProductsPrice={totalPrice}
                        deleteCartProduct={DeleteCartProduct}
                        selectedProducts={selectedProducts} />} >
                    </Route>
                        <Route path="/payment-success" element={<PaymentFinish />}></Route>
                        <Route path="/blog" element={<Blog setLoading={setLoading} />}></Route>
                        <Route path="/profile" element={<Profile id={id} loading={loading} setLoading={setLoading} />}></Route>
                        <Route path="/forgotpassword" element={<ForgotPassword/>}></Route>
                        <Route path="/login" element={<Login loading={loading} setLoading={setLoading} token={token} setToken={setToken} removeToken={removeToken} />}></Route>
                    {/*Admin pages*/}
                    <Route path="/dashboard/products" element={
                        <PrivateRoute role="Admin"><Dashboard Element={
                            <AdminProduct loading={loading} setLoading={setLoading} />
                        } removeToken={removeToken} />
                        </PrivateRoute>
                    }></Route>
                    <Route path="/dashboard/orders" element={
                        <PrivateRoute role="Admin">
                            <Dashboard Element={
                                <AdminOrders setLoading={setLoading} />
                            } removeToken={removeToken} />
                        </PrivateRoute>
                    }></Route>
                    <Route path="/dashboard/order-detail" element={
                        <PrivateRoute role="Admin">
                            <Dashboard Element={
                                <AdminOrderDetail
                                    uid={id}
                                    setLoading={setLoading} />
                            } removeToken={removeToken} />

                        </PrivateRoute>
                    } >
                       
                        <Route path=":id" element={
                            <PrivateRoute role="Admin">
                                <Dashboard Element={
                                    <AdminOrderDetail
                                        uid={id}
                                        setLoading={setLoading} />
                                } removeToken={removeToken} />
                            </PrivateRoute>
                        } />
                    </Route>

                    <Route path="/dashboard/users" element={
                        <PrivateRoute role="Admin">
                            <Dashboard Element={
                                <AdminUser id={id} loading={loading} setLoading={setLoading} />
                            } removeToken={removeToken} />
                        </PrivateRoute>
                    }></Route>
                    <Route>
                        <Route path="/dashboard/create-blog" element={
                            <PrivateRoute role="Admin">
                                <Dashboard Element={
                                    <AdminCreateBlog setLoading={setLoading} id={id} />
                                } removeToken={removeToken} />
                            </PrivateRoute>
                        } />
                    </Route>
                    <Route>
                        <Route path="/dashboard/blog" element={
                            <PrivateRoute role="Admin">
                                <Dashboard Element={
                                    <AdminBlogManagement setLoading={setLoading} id={id} />
                                } removeToken={removeToken} />
                            </PrivateRoute>
                        } />
                    </Route>
                    <Route>
                        <Route path="/dashboard/" element={
                            <PrivateRoute role="Admin">
                                <Dashboard Element={
                                    <ChartPage setLoading={setLoading} />
                                } removeToken={removeToken} />
                            </PrivateRoute>
                        } />
                    </Route>
                    <Route path="/AdminProductDetail" element={
                        <PrivateRoute role="Admin">
                            <Dashboard Element={
                                <AdminProductDetail GetProductSize={GetProductSize} token={token} fetchCartProducts={fetchProductsInCart} products={cartProducts} setProducts={setCartProducts}
                                    setSuccessMessage={setSuccessMessage} setLoading={setLoading} />
                            } removeToken={removeToken} />

                        </PrivateRoute>
                    }>

                        <Route path=":id" element={<PrivateRoute role="Admin">
                            <Dashboard Element={
                                <AdminProductDetail GetProductSize={GetProductSize} token={token} fetchCartProducts={fetchProductsInCart} products={cartProducts} setProducts={setCartProducts}
                                    setSuccessMessage={setSuccessMessage} setLoading={setLoading} />
                            } removeToken={removeToken} />
                        </PrivateRoute>} />
                    </Route>
                    {/* <Route path="/AdminAddProduct" element={
                            <PrivateRoute role="Admin">
                                <AdminAddProduct />
                            </PrivateRoute>
                        }></Route> */}
                    <Route path="*" element={<NotFound />}></Route>
                </Route>
            </Routes>
        </BrowserRouter>
    )
}


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <ThemeProvider>
            <App />
        </ThemeProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
